import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fc29d09c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "error-page__title" }
const _hoisted_4 = { class: "error-page__notice" }
const _hoisted_5 = {
  key: 2,
  class: "error-page__actions-wrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "error-page__end-point" }, ".", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_SupportModal = _resolveComponent("SupportModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: `/img/error${_ctx.errorCode}.svg`,
      alt: "Error Image"
    }, null, 8, _hoisted_2),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(`common.errors.${_ctx.errorCode}.title`)), 1),
    _createElementVNode("p", _hoisted_4, [
      (_ctx.showDefaultErrorMessage)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.$t(`common.errors.${_ctx.errorCode}.notice`)), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(_ctx.$t(`common.errors.${_ctx.errorCode}.noticeSupporter`)), 1)
          ], 64)),
      (_ctx.showDefaultErrorMessage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.actionText) + " ", 1),
            _createVNode(_component_PxButton, {
              ref: "returnToHomepageButton",
              label: _ctx.actionLink,
              class: "error-page__action",
              type: "link",
              onClick: _ctx.returnHomepage
            }, null, 8, ["label", "onClick"]),
            (_ctx.showSupportModal)
              ? (_openBlock(), _createBlock(_component_i18n_t, {
                  key: 0,
                  keypath: "common.errors.actions.contactSupport.text",
                  tag: "span"
                }, {
                  action: _withCtx(() => [
                    _createVNode(_component_PxButton, {
                      ref: "contactSupportButton",
                      label: _ctx.$t(`common.errors.actions.contactSupport.action`),
                      class: "error-page__action",
                      type: "link",
                      onClick: _ctx.showModal
                    }, null, 8, ["label", "onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_SupportModal, {
      visibility: _ctx.supportModalVisibility,
      "onUpdate:visibility": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.supportModalVisibility) = $event))
    }, null, 8, ["visibility"])
  ]))
}